import { Component, OnInit, ViewContainerRef, Inject, LOCALE_ID } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
import { AccountService } from './services/account.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { ParametersService } from './services/parameters.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor( private toastr: ToastsManager,
    private vcr: ViewContainerRef,
    public translate: TranslateService,
    @Inject(LOCALE_ID) locale: string,
    public accountService: AccountService) {
      toastr.setRootViewContainerRef(vcr);
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts